import { type CollaboratorDetails } from "@vega-api/generated/types/collaboratorDetails";
import { Avatar } from "@vega-core/components/Avatar/Avatar";
import { m } from "@vega-core/paraglide/messages";
import { formatShortSlashDate } from "@vega-core/utils/formatDate";

type Props = {
  collaboratorName: string;
  selectedCollaborator: CollaboratorDetails | null;
};

export const CollaboratorsSideDrawerHeader = ({
  collaboratorName,
  selectedCollaborator,
}: Props) => (
  <div className="flex justify-between items-center border-b border-border/secondary pb-6">
    <div className="flex gap-2">
      <Avatar
        className="w-10 h-10"
        fontClassName="heading-4"
        initials={collaboratorName ? collaboratorName[0] : ""}
      />
      <div>
        <div className="body-base-medium text-text/primary capitalize">
          {collaboratorName}
        </div>
        <div className="flex flex-col body-base-medium text-text/secondary">
          {selectedCollaborator?.email.toLocaleLowerCase() || "-"}
        </div>
      </div>
    </div>
    <div className="body-small-regular text-text/secondary">
      {m.common_lastActive()}{" "}
      {selectedCollaborator?.lastActivity
        ? formatShortSlashDate(selectedCollaborator.lastActivity)
        : "-"}
    </div>
  </div>
);
